export default {
    calculator: state => state.calculator,
    calculatorParameters: state => state.calculatorParameters,
    getWeight: state => state.weight,
    getVolume: state => state.volume,
    getFluidRateUnit: state => state.fluidRateUnit,
    getFluidRate: state => state.fluidRate,
    getCurrentHematocrit: state => state.currentHematocrit,
    getDonorHematocrit: state => state.donorHematocrit,
    getIntendedHematocrit: state => state.intendedHematocrit,
    getAnimal: state => state.animal,
    
    getDrugs: state => state.drugs,
    drugsConcentrations: state => state.drugsConcentrations,
};